import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { appBridge } from '../../../shared/services/bridge';
import './SurveyComplete.css';

type FeatureType = 'inquiry' | 'inspection';

const SurveyComplete: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // URLパスまたはstateからfeatureTypeを判定
  const featureType: FeatureType = (location.state?.featureType as FeatureType) ||
    (location.pathname.includes('/inspections/') ? 'inspection' : 'inquiry');

  // 画面表示時にアプリ内レビューダイアログを表示
  useEffect(() => {
    appBridge.showReview();
  }, []);

  const handleComplete = () => {
    // featureTypeに応じて遷移先を分岐
    if (featureType === 'inspection') {
      navigate('/inspections', { replace: true });
    } else {
      navigate('/inquiries', { replace: true });
    }
  };

  return (
    <div className="survey-complete-container">
      <main className="survey-complete-content">
        <img src="/assets/images/check-circle.png" alt="完了" className="survey-complete-icon" />
        <h2 className="survey-complete-title">アンケートを送信しました</h2>
        <p>ご協力ありがとうございました</p>
      </main>
      <footer className="survey-complete-footer">
        <button
          className="button-primary"
          onClick={handleComplete}
        >
          トップに戻る
        </button>
      </footer>
    </div>
  );
}

export default SurveyComplete;
